export default __webpack_public_path__ + "static/media/icon_lab orders.331d3600.svg";